import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "6", y1: "3", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "18", y1: "3", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "6", y1: "21", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "18", y1: "21", y2: "18", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Currency";
const Currency = memo(themed(Icon));
export {
  Currency
};
//# sourceMappingURL=currency.js.map
